"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosRecommendationRequest = void 0;
var AxiosQon_1 = require("../../utils/AxiosQon");
var AxiosRecommendationRequest = /** @class */ (function () {
    function AxiosRecommendationRequest(config) {
        this.config = config;
        this.axios = (new AxiosQon_1.AxiosQon(config)).axiosInstance;
    }
    AxiosRecommendationRequest.prototype.getRecommendations = function (url) {
        return this.axios.get(url);
    };
    return AxiosRecommendationRequest;
}());
exports.AxiosRecommendationRequest = AxiosRecommendationRequest;
//# sourceMappingURL=AxiosRequest.js.map